module.exports = __webpack_public_path__ + "assets/images/novasports_premier_league.f34c73cf077a2b223b0bbbcc102b2081.png";